<app-header></app-header>
<div class="nf404">
    <div class="content text-center">
        <h1>Lost your way?</h1>
        <p>Sorry, we can't find that page. You'll find lots to explore on the home page.</p>
        <button routerLink="./" class="btn_red2" tabindex="0">Back Home</button>
    </div>
</div>
<app-footer></app-footer>